export const SET_LOCATION = "setLocation";

export const setLocation = (payload: any) => {
  return {
    type: SET_LOCATION,
    payload,
  };
};
